import React from 'react'
import styled from 'styled-components'
import CalendarField from '../../../components/Calendar/CalendarField/CalendarField'
import ListSelect from '../../../components/ListSelect/ListSelect'
import Icons from '../../../components/Icons'
import {
  useWorkspaceState,
  useWorkspaceDispatch
} from '../../../context/WorkspaceContext'
import {_L, useLocaleState} from '../../../context/LocaleContext'

const WorkspaceMiniFilter = ({onShowFilter, onSearch, locale}) => {
  const localeState = useLocaleState()
  const {search} = useWorkspaceState()
  const workspaceDispatch = useWorkspaceDispatch()

  const {recurrenceType, date_end, date_start, dayPart} = search

  const workspaceSetSearch = payload =>
    workspaceDispatch({type: 'setWorkspaceSearch', payload})

  const options = [
    {value: 0, label: _L({key: 'Full day', localeState})},
    {value: 1, label: _L({key: 'Morning', localeState})},
    {value: 2, label: _L({key: 'Afternoon', localeState})}
  ]

  const onSelectStartDate = date => {
    let date_start = new Date(date)

    let newState = {date_start}

    if (
      recurrenceType === 'none' ||
      date_end.getTime() < date_start.getTime()
    ) {
      newState = {date_start, date_end: date_start}
    }

    workspaceSetSearch(newState)
  }

  const onDayPartSelected = dayPart =>
    workspaceSetSearch({dayPart: dayPart.value})

  const doSearch = () => onSearch(search)

  return (
    <StyledContainer>
      <StyledHeader>
        {_L({key: 'Select a workspace', localeState})}
      </StyledHeader>
      <StyledForm>
        <CalendarContainer>
          <CalendarField
            onSelect={onSelectStartDate}
            locale={locale}
            date={date_start.toISOString()}
          />
        </CalendarContainer>
        <StyledListSelect>
          <ListSelect
            options={options}
            placeholder=""
            isSearchable={false}
            value={options.filter(({value}) => value === dayPart)}
            onChange={onDayPartSelected}
          />
        </StyledListSelect>
        <StyledIcon onClick={doSearch}>
          <Icons icon="SEARCH" width={24} height={24} />
        </StyledIcon>
      </StyledForm>
      <StyledFooter>
        <StyledLink onClick={onShowFilter}>
          {_L({key: 'More options / Make recurring', localeState})}
        </StyledLink>
      </StyledFooter>
    </StyledContainer>
  )
}

export default WorkspaceMiniFilter

const StyledContainer = styled.div`
  background-color: white;
  box-sizing: border-box;
  position: relative;
`
const StyledHeader = styled.div`
  padding: 15px 20px 0 20px;
  font-size: 20px;
  font-weight: 600;
  box-sizing: border-box;
`
const StyledForm = styled.div`
  padding: 10px 20px;
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
`
const StyledListSelect = styled.div`
  padding-left: 20px;
  width: 250px;
  box-sizing: border-box;
  @media (max-width: 420px) {
    display: none;
  }
`
const StyledIcon = styled.div`
  margin-left: 20px;
  width: 46px;
  height: 46px;
  background: #3396fe;
  border-radius: 4px;
  padding: 11px;
  box-sizing: border-box;
`
const StyledFooter = styled.div`
  padding: 0 20px 15px 20px;
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
`
const StyledLink = styled.a`
  color: #3396fe;
  font-weight: 600;
  font-size: 14px;
  box-sizing: border-box;
  padding-top: 2px;
`

const CalendarContainer = styled.div`
  width: 240px;
`
